import React, { FC } from "react";
import displayUserName from "../../../../../utils/display-username";
import { conversationTypeList, groupChannelTypeList } from "../../../constants";
import { ChatHeaderContentInfoStyled } from "../../../style";
import { ChatListType, ConversationsType } from "../../../types";
import { ConversationTypeEnum } from "../../../types/enums";
import Stack from "react-bootstrap/esm/Stack";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";

interface Props {
  type?: ConversationsType | "home";
  chat?: ChatListType;
}

const Content: FC<Props> = (props) => {
  const { t } = useAppTranslation("common");

  return (
    <ChatHeaderContentInfoStyled>
      <span className="text-bold fs-lg text-capitalize">
        {displayUserName(
          groupChannelTypeList.includes(props.type!)
            ? props?.chat?.name!
            : props?.chat?.user?.username!,
          20
        )}
      </span>
      <Stack direction="vertical">
        {conversationTypeList.includes(props.type!) && (
          <span className="text-normal text-secondary fs-tiny text-capitalize">
            {props.type === ConversationTypeEnum.PERSONAL ? (
              <>
                {props?.chat?.user?.isOnline
                  ? t("chat.status.online")
                  : t("chat.status.personal")}
              </>
            ) : (
              <>
                {t("chat.status.membersOnline", {
                  members: props.chat?.membersGroup?.count || 0,
                  online: props.chat?.membersIsOnline ?? 0,
                })}
              </>
            )}
          </span>
        )}
      </Stack>
    </ChatHeaderContentInfoStyled>
  );
};

export default Content;
